import React from "react";
import styled from "styled-components";
import theme from "theme";
import { sectionIds } from "content/site";
import SiteHeader from "components/layout/SiteHeader";
import SiteFooter from "components/layout/SiteFooter";

const SkipAnchor = styled.a`
	position: absolute;
	left: -9999px;
	top: 0;
	z-index: 100;
	padding: 0.75rem 1rem;
	background: ${theme.color.dark};
	color: #fff;
	font-family: ${theme.fontFamily.sans};
	font-weight: 600;
	text-decoration: none;
	border-radius: 0 0 6px 0;
	&:focus {
		left: 0.5rem;
		top: 0.5rem;
		outline: 2px solid ${theme.color.primary};
		outline-offset: 2px;
	}
`;

const Page = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`;

const Main = styled.main`
	flex: 1;
`;

export default function SiteLayout({ children }) {
	return (
		<Page>
			<SkipAnchor href={`#${sectionIds.main}`}>Skip to main content</SkipAnchor>
			<SiteHeader />
			<Main id={sectionIds.main} tabIndex={-1}>
				{children}
			</Main>
			<SiteFooter />
		</Page>
	);
}
